import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import { useStyles } from './style';

export const ScenePreview = ({ scenes, selectedSceneId }) => {
  const currentScene = useMemo(() => scenes[selectedSceneId], [scenes, selectedSceneId]);
  const { keyFrame } = (currentScene && currentScene.effective) || { keyFrame: { url: '' } };
  const classes = useStyles();
  return (
    <div className={mergeClasses(classes.scenePreviewContainer, 'scene-preview-container')}>
      <img
        className={mergeClasses(classes.scenePreviewImage, 'scene-preview-image')}
        src={keyFrame.url}
        alt="scene-preview"
      />
    </div>
  );
};

ScenePreview.propTypes = {
  scenes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedSceneId: PropTypes.number.isRequired,
};
